'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareHeaders = exports.parseHeaders = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _isFunction = require('../validators/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isObject = require('../validators/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * @description :: Iterating over headers and combining them
 * @param {Array} headers :: The array of headers
 * @return {Object} :: Combined and validated header object
 */
// Validators


var parseHeaders = exports.parseHeaders = function parseHeaders(headers) {
  return headers.reduce(function (combined, _header) {
    var header = (0, _isFunction2.default)(_header) ? _header() : _header;

    if (!(0, _isObject2.default)(header)) {
      console.warn('Expecting an object or a function that returns an object for the header but got ' + (typeof header === 'undefined' ? 'undefined' : (0, _typeof3.default)(header)));
      return (0, _extends3.default)({}, combined);
    }

    return (0, _extends3.default)({}, combined, header);
  }, {});
};
/**
 * @description :: Preparing headers for the fetch execition
 * @param {Array} headers :: Array of headers
 * @return {Headers} :: Headers object
 */


var prepareHeaders = exports.prepareHeaders = function prepareHeaders() {
  for (var _len = arguments.length, headers = Array(_len), _key = 0; _key < _len; _key++) {
    headers[_key] = arguments[_key];
  }

  return new Headers(parseHeaders(headers));
};